import React from 'react';
import KetListenPart4 from './KetListenPart4';

// KET Listening Part 5 uses the exact same form gap-fill data shape and layout
// as Listening Part 4 (content_data.form_title + prefilled rows + typed answers).
const KetListenPart5 = (props) => <KetListenPart4 {...props} />;

export default KetListenPart5;
